import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap5';

import routes from 'app/routes';
import { useContext } from 'components/Managers/Dashboard/Context';
import useApiData from 'components/Managers/Dashboard/Hooks/useApiData';
import StatisticButton from './StatisticButton';
import StatisticModal from './StatisticModal';

export default function AssignedStatistic({ value }) {
  const [showModal, setShowModal] = useState(false);
  const route = routes.api.managers.dashboard.programs_assigned;
  const { state: { filters } } = useContext();
  const { data: programs, loading: programsLoading } = useApiData(showModal && route, filters);

  const columns = [
    {
      name: 'First Name',
      selector: (row) => row.first_name,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Last Name',
      selector: (row) => row.last_name,
      sortable: true,
      searchable: true,
    },
    {
      name: 'Program',
      selector: (row) => row.program_title,
      sortable: true,
      searchable: true,
    },
  ];

  return (
    <Col md="4" className="mb-2 mb-md-0">
      <StatisticButton
        label="Assigned"
        value={value}
        onClick={() => setShowModal(true)}
        className="bg-primary-50"
      />

      <StatisticModal
        show={showModal}
        title="Assigned"
        columns={columns}
        data={programsLoading ? null : programs}
        onCloseClick={() => setShowModal(false)}
      />
    </Col>
  );
}

AssignedStatistic.propTypes = {
  value: PropTypes.number,
};

AssignedStatistic.defaultProps = {
  value: null,
};
